import { render, staticRenderFns } from "./ServerAdd.vue?vue&type=template&id=bc6dbeb2&"
import script from "./ServerAdd.vue?vue&type=script&lang=js&"
export * from "./ServerAdd.vue?vue&type=script&lang=js&"
import style0 from "./ServerAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports